import firebase from './firebase';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

const firestore = getFirestore(firebase);

const hostname = window.location.hostname;
if (hostname === 'localhost' || hostname === '127.0.0.1') {
  connectFirestoreEmulator(firestore, hostname, 8080);
}

export default firestore;
